module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-63c3b709!./packages/dof-popup/diablo.css
// module id = 495
// module chunks = 0 1